// @flow

import React, {Component} from 'react'
import {ACTION_LOCALE_CHANGE} from '../constants'
import {connect} from "react-redux"
import type {Locale, Action, actionLocaleChange} from '../types'


function mapStateToProps(state, ownProps) {

  return {
    locale: state.locale
  }
}

const mapDispatchToProps = {
  changeLanguage: (locale: Locale):actionLocaleChange => {
    return {
      type: ACTION_LOCALE_CHANGE,
      locale: locale
    }
  }
}


class LanguageSelect extends Component{

  props:{
    locale: Locale,
    changeLanguage: (locale:Locale)=>void
  }

  changeLanguage = (event) => {
    this.props.changeLanguage(event.target.value)
  }

  render(){
    return (
      <select className="form-control m-b" value={this.props.locale} onChange={this.changeLanguage}>
        <option value="en">English</option>
        <option value="zh-cn">中文简体</option>
        <option value="zh-tw">中文繁體</option>
        <option value="ja">Japanese - 日本語</option>
        <option value="ro">Romanian - română</option>
        <option value="tr">Turkish - Türkçe</option>
        <option value="id">Indonesian</option>
        <option value="de">German - Deutsch</option>
        {/*<option value="pl">Polish</option>
          <option value="th">Thai - ภาษาไทย</option>
          <option value="es">Spanish - español</option>
          */}
      </select>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LanguageSelect)



// WEBPACK FOOTER //
// ./src/components/LanguageSelect.js